<div class="modal-header">
    <h7 *ngIf="type === 'Create'" cvLocalizedText langSection="CXOne_Modal" langKey="Create_Report">Create Report</h7>
    <h7 *ngIf="type === 'Edit'" cvLocalizedText langSection="CXOne_Modal" langKey="Edit_Report">Edit Report</h7>
    <button type="button" (click)="cancel();"
        class="modal-close icon-btn fill-valyrianSteel fill-hover-whaleTail">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
        </svg>
    </button>
</div>
<div class="modal-body cxone-report-body">
    <div class="mb-3">
        <div class="subtitle-1 mb-2" cvLocalizedText langSection="CXOne_Modal" langKey="Name">Name</div>
        <div>
            <input #reportName="ngModel" class="reportInputInput form-control form-control-lg cxoneInput"
                ngbAutoFocus name="reportName" [(ngModel)]="data.name"
                (ngModelChange)="characterLimit(data.name)"
                [ngStyle]="{ 'border-color': reportName.errors?.['pattern'] && '#bd2026' }"
                [required]="true" maxlength="50" type="text" [pattern]="invalidCharsRegex" cvLocalizedPlaceholder
                langSection="Common" langKey="Required"/>
            <div class="character-limit" [hidden]="reportName.errors?.['pattern']">
                <span>{{ getTextLimitMessage(data.name) }} </span>
            </div>
            <div [hidden]="!reportName.errors?.['required']" class="ml-1 color-redRyder"
                cvLocalizedText langSection="Users" langKey="Required"></div>
        </div>
        <div [hidden]="!reportName.errors?.['pattern']" class="ml-1 color-redRyder" cvLocalizedText
            langSection="Dashboard_Input" langKey="PatternError"></div>
    </div>
    <div class="mb-3">
        <div class="subtitle-1 mb-2" cvLocalizedText langSection="CXOne_Modal" langKey="Permission_Name">Permission Name</div>
        <div>
            <input #reportPermissionName="ngModel" class="reportInputInput form-control form-control-lg cxoneInput"
                ngbAutoFocus name="reportPermissionName" [(ngModel)]="data.permissionName"
                (ngModelChange)="characterLimit(data.permissionName)"
                [ngStyle]="{ 'border-color': reportPermissionName.errors?.['pattern'] && '#bd2026' }"
                [required]="true" maxlength="50" type="text" [pattern]="invalidCharsNoSpacesRegex" cvLocalizedPlaceholder
                langSection="Common" langKey="Required" [disabled]="type !== 'Create'"/>
            <div class="character-limit" [hidden]="reportPermissionName.errors?.['pattern'] || type !== 'Create'">
                <div class="character-limit" [hidden]="reportPermissionName.errors?.['pattern']">
                    <span>{{ getTextLimitMessage(data.permissionName)}} </span>
                </div>
            <div [hidden]="!reportPermissionName.errors?.['required']" class="ml-1 color-redRyder"
                cvLocalizedText langSection="Users" langKey="Required"></div>
        </div>
        <div [hidden]="!reportPermissionName.errors?.['pattern']" class="ml-1 color-redRyder" cvLocalizedText
            langSection="Dashboard_Input" langKey="PatternError"></div>
    </div>
    <div class="mb-3">
        <div class="subtitle-1 mb-2" cvLocalizedText langSection="CXOne_Modal" langKey="Description">Description</div>
        <div>
            <textarea #description="ngModel" [(ngModel)]="data.description"
                [ngStyle]="{ 'border-color': description.errors?.['pattern'] && '#bd2026' }"
                [maxlength]="255" rows="7" style="resize: none; padding: 0.5rem;"
                class="reportInputInput form-control form-control-lg cxoneInput" type="text" name="description"
                [pattern]="invalidDescriptionCharsRegex" cvLocalizedPlaceholder langSection="CXOne_Modal"
                langKey="Description"></textarea>
        </div>
        <div [hidden]="!description.errors?.['pattern']" class="ml-1 color-redRyder" cvLocalizedText
            langSection="Dashboard_Input" langKey="PatternError"></div>
    </div>
    <div class="mb-3">
        <div class="subtitle-1 mb-2" cvLocalizedText langSection="CXOne_Modal" langKey="Selected_Domains">Domains</div>
        <cxone-multiselect-dropdown #domains="ngModel" [(ngModel)]="selectedDomainsList" [options]="domainsList" [isRequired]="true" 
            [sortOrder]="'unsort'" [showFooter]="false" (selectionChanged)="onDomainsSelectionChanged($event)" name="domains">
        </cxone-multiselect-dropdown>
    </div>
    <div class="mb-3">
        <div class="subtitle-1 mb-2" cvLocalizedText langSection="CXOne_Modal" langKey="User_Type">Persona</div>
        <cxone-multiselect-dropdown #userType="ngModel" [(ngModel)]="selectedPersonaList" [options]="personaList" [isRequired]="true" 
            [sortOrder]="'unsort'" [showFooter]="false" (selectionChanged)="onPersonaSelectionChanged($event)" name="personas">
        </cxone-multiselect-dropdown>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn cancelButton footerButton mr-2" (click)="cancel();" cvLocalizedText langSection="CXOne_Modal" langKey="Cancel">
        Cancel
    </button>
    <button type="button" class="cancelButton footerButton" class="btn btn-primary" *ngIf="type === 'Create'"
        [disabled]="reportName.invalid || isStringEmpty(reportName.value) || reportPermissionName.invalid || isStringEmpty(reportPermissionName.value) || 
        description.invalid || domains.invalid || userType.invalid" (click)="save()">
        <span cvLocalizedText langSection="CXOne_Modal" langKey="Create">Create</span>
    </button>
    <button type="button" class="cancelButton footerButton" class="btn btn-primary" *ngIf="type === 'Edit'"
        [disabled]="reportName.invalid || isStringEmpty(reportName.value) || reportPermissionName.invalid || isStringEmpty(reportPermissionName.value) || 
        description.invalid || domains.invalid || userType.invalid" (click)="save()">
        <span cvLocalizedText langSection="CXOne_Modal" langKey="Save">Save</span>
    </button>
</div>
